/** @format */

import React from 'react';

import {useTheme} from '@mui/material/styles';

import {formatNumber} from 'helpers/formatNumber';

import {toStr} from 'helpers/stringHelpers';

import {ProgressBarContainer, CenterLine, BarWrapper, Bar, DifferenceText} from './styles';

interface ProgressBarProps {
  value: number;
  maxValue: number;
  isPositive: boolean; // true = зеленый (вправо), false = красный (влево)
  kpiName?: string;
  difference?: number | null;
}

const ProgressBar: React.FC<ProgressBarProps> = ({
  value,
  maxValue,
  isPositive,
  kpiName = '',
  difference = null,
}) => {
  const theme = useTheme();
  const absValue = Math.abs(value);
  const absMaxValue = Math.abs(maxValue);
  const percentage = absMaxValue > 0 ? (absValue / absMaxValue) * 100 : 0;
  const normalizedUnits = kpiName === 'ДРР' ? 'п.п.' : '₽';

  const differenceText =
    difference !== null && difference !== 0
      ? `${difference > 0 ? '+' : '-'}${formatNumber(Math.abs(difference))} ${normalizedUnits}`
      : '';

  const backgroundColor = isPositive
    ? theme.palette.semantic_dark?.secondary.main
    : theme.palette.semantic_dark?.bad.main;

  if (!absValue) return null;

  return (
    <ProgressBarContainer data-testid='progress-bar-container'>
      <CenterLine data-testid='progress-bar-center-line' />
      <BarWrapper>
        <Bar
          isPositive={isPositive}
          percentage={percentage}
          backgroundColor={toStr(backgroundColor)}
          data-testid='progress-bar-bar'
        >
          {differenceText && (
            <DifferenceText data-testid='progress-bar-difference-text'>
              {differenceText}
            </DifferenceText>
          )}
        </Bar>
      </BarWrapper>
    </ProgressBarContainer>
  );
};

export default ProgressBar;
